<!-- Equivalent of old h6 -->
<h5 class="thin dk-gray">{{ text }} <i *ngIf="icon" class="fa" [ngClass]="'fa-' + icon"></i></h5>
